import apiClient from '../axios';

const vendorApplicationService = {
  // Get all vendor applications
  async getAllApplications() {
    try {
      const response = await apiClient.get('admin/vendor-applications');
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to fetch vendor applications',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch vendor applications',
        errors: error.response?.data?.errors
      };
    }
  },

  // Get vendor application by ID
  async getApplicationById(id) {
    try {
      const response = await apiClient.get(`admin/vendor-applications/${id}`);
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to fetch vendor application',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to fetch vendor application',
        errors: error.response?.data?.errors
      };
    }
  },


  // Approve vendor application
  async approveApplication(id, adminNotes = '') {
    try {
      const payload = {};
      if (adminNotes) {
        payload.admin_notes = adminNotes;
      }
      
      // Debug logging
      console.log('Service payload:', {
        adminNotes: adminNotes
      });
      
      const response = await apiClient.post(`admin/vendor-applications/${id}/approve`, payload);
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to approve vendor application',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to approve vendor application',
        errors: error.response?.data?.errors
      };
    }
  },

  // Reject vendor application
  async rejectApplication(id, adminNotes = '') {
    try {
      const payload = {};
      if (adminNotes) {
        payload.admin_notes = adminNotes;
      }
      
      // Debug logging
      console.log('Rejection service payload:', {
        adminNotes: adminNotes
      });
      
      const response = await apiClient.post(`admin/vendor-applications/${id}/reject`, payload);
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true, data: response.data.data };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to reject vendor application',
          errors: response.data.errors
        };
      }
    } catch (err) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to reject vendor application',
        errors: error.response?.data?.errors
      };
    }
  },

  // Delete vendor application
  async deleteApplication(id) {
    try {
      const response = await apiClient.delete(`admin/vendor-applications/${id}`);
      if (response.data && (response.data.success === true || response.data.status === 'success')) {
        return { success: true };
      } else {
        return {
          success: false,
          message: response.data.message || 'Failed to delete vendor application',
          errors: response.data.errors
        };
      }
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || 'Failed to delete vendor application',
        errors: error.response?.data?.errors
      };
    }
  },


  // Helper method to create FormData for application submission with file upload
  createApplicationFormData(applicationData) {
    const formData = new FormData();
    
    // Add all text fields
    Object.keys(applicationData).forEach(key => {
      if (key !== 'profile_image' && applicationData[key] !== null && applicationData[key] !== undefined) {
        formData.append(key, applicationData[key]);
      }
    });

    // Add profile image if present
    if (applicationData.profile_image && applicationData.profile_image instanceof File) {
      formData.append('profile_image', applicationData.profile_image);
    }

    return formData;
  }
};

export default vendorApplicationService; 